"use client";

import PedigreeIcon from "@/app/shared/icons/PedigreeIcon";
import AdDetailModel from "@/models/AdDetailModel";
import { AdPedigreeTreeNode } from "@/sell/models/AdPedigreeTree";
import { Box, Typography } from "@mui/material";
import Image from "next/image";

function PedigreeTreeItem({
  item,
  imageUrl,
  level,
  parent,
}: {
  item?: AdPedigreeTreeNode | null;
  imageUrl?: string;
  level: number;
  parent?: AdPedigreeTreeNode | null;
}) {
  const imageSize = imageUrl ? 100 : 50;
  const numLevels = 3;
  let offset;
  switch (level) {
    case 1:
      offset = "-100px";
      break;
    case 2:
      offset = "-240px";
      break;
    default:
      offset = "initial";
  }
  if (level === 0 && item && !item.name) {
    item.name = ' ';
  }
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: level === 0 ? "initial" : "300px",
          margin: 1,
          padding: 1,
          gap: 2,
          flexShrink: 0,
          backgroundColor:
            !item || !item.name
              ? "grey.100"
              : !imageUrl
                ? "gender" in item && item?.gender === "sire"
                  ? `#85c9e855`
                  : `#f7b1c755`
                : "none",
          borderRadius: "1000px",
          marginLeft: offset,
          img: {
            width: imageSize + "px",
            height: imageSize + "px",
            borderRadius: "1000px",
            objectFit: "cover",
          },
          p: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      >
        {/* AJB: CAN THIS BE DISTORTED? */}
        {/* AJB: use smaller image thumbnail here */}
        {item && item.name && (
          <Image
            src={imageUrl ?? "/icons/horse.png"}
            alt={item?.name}
            width={imageSize}
            height={imageSize}
            unoptimized
          />
        )}

        <Box>
          {level > 0 && (
            <Typography variant="h6">{item?.name || <>&nbsp;</>}</Typography>
          )}
          {/* AJB: elipsis or expand */}
          <Typography variant="body2">
            {item && item.name ? (
              <>
                {parent?.name?.trim() && <>{parent.name}&apos;s </>}
                {"gender" in item && item.gender}
              </>
            ) : (
              <>&nbsp;</>
            )}
          </Typography>
        </Box>
      </Box>
      <Box>
        {level < numLevels && item && "sire" in item && (
          <PedigreeTreeItem item={item.sire} level={level + 1} parent={item} />
        )}
        {level < numLevels && item && "dam" in item && (
          <PedigreeTreeItem item={item.dam} level={level + 1} parent={item} />
        )}
      </Box>
    </Box>
  );
}

export default function AdPedigreeTree({ ad }: { ad: AdDetailModel }) {
  return (
    <>
      {ad.pedigreeTree?.sire && ad.pedigreeTree?.dam && (
        <Box>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              svg: {
                height: "30px",
              },
            }}
          >
            <PedigreeIcon />
            Pedigree Tree
          </Typography>
          <Box
            sx={{
              overflow: "auto",
            }}
          >
            <PedigreeTreeItem
              item={ad.pedigreeTree}
              imageUrl={ad.gallery.items[0]?.thumbnail}
              level={0}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
